import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';

@Injectable()
export class InspectionCubesService {

    constructor(
      private apiService: ApiService
    ) {
      this.apiService.init();
    }

    getOptions(): Observable<any[]> {
      return this.apiService.client.serviceOrders.customstore.options.GET()
        .map((res) => {
          return this.apiService.handleResponse(res);
        });
    }

    getServiceOrders(loadOptions?: string): Promise<any> {
      return this.apiService.client.serviceOrders.customstore.GET(loadOptions)
        .map((res) => {
          return this.apiService.handleResponse(res);
        })
        .toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/api/inspection-cubes.service.ts